import React, { useEffect, useState, useCallback } from 'react';
import useAxiosConfig from '../../config/AxiosConfig';
import { Autocomplete, MenuItem, TextField } from '@mui/material';

const GroundSettlementFilter = ({
  handleDateValues,
  handleSelectedSports,
  sportId,
  handleSearchValues,
  searchValue,
  cityFilter,
  handleSelectedCity,
}) => {
  const axiosInstance = useAxiosConfig();

  // const [cityFilter, setCityFilter] = useState("");
  const [sportsData, setSportsData] = useState([]);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const fetchAllSports = useCallback(async () => {
    try {
      const response = await axiosInstance.get('/api/ground/get-all-sports');
      const sports = response?.data?.data;
      setSportsData(sports);
    } catch (error) {
      console.log('Error fetching sports', error);
    }
  }, [axiosInstance]);
  const handleClick = id => {
    handleSelectedSports(id);
  };
  const handleCityFilterChange = event => {
    // setCityFilter(event.target.value);
    handleSelectedCity(event.target.value);
  };

  useEffect(() => {
    fetchAllSports();
  }, [fetchAllSports]);
  return (
    <div className="flex flex-row justify-end gap-4 mr-4">
      {' '}
      <TextField
        type="text"
        label="Search by ground name"
        value={searchValue}
        onChange={e => handleSearchValues(e.target.value)}
        size="small"
      />
      <Autocomplete
        options={sportsData}
        onClick={handleClick}
        getOptionLabel={option => option.name}
        size="small"
        style={{ width: 150, marginBottom: '16px' }}
        value={sportsData.find(sport => sport._id === sportId) || null}
        renderInput={params => (
          <TextField
            {...params}
            label="Select Sports"
            InputProps={{
              ...params.InputProps,
              endAdornment: params.InputProps.endAdornment,
            }}
          />
        )}
        onChange={(event, newValue) => {
          if (newValue) {
            handleSelectedSports(newValue._id);
          } else {
            handleSelectedSports(''); // Pass null to indicate selection has been cleared
          }
        }}
        isOptionEqualToValue={(option, value) => option._id === value?._id}
      />
      <TextField
        type="text"
        value={cityFilter}
        label="City"
        size="small"
        sx={{ maxWidth: '180px' }}
        select
        onChange={handleCityFilterChange}>
        <MenuItem value="All">All</MenuItem>
        <MenuItem value="Islamabad/Rawalpindi">ISB/RWP</MenuItem>
        <MenuItem value="Lahore">Lahore</MenuItem>
        <MenuItem value="Karachi">Karachi</MenuItem>
        <MenuItem value="Peshawar">Peshawar</MenuItem>
      </TextField>
      <TextField
        label="Start Date"
        type="date"
        value={startDate}
        onChange={e => {
          // Check if this is a real user selection rather than month navigation
          if (e.target.value !== startDate) {
            setStartDate(e.target.value);
            console.log('the clicked date is this one ', e.target.value);
            handleDateValues('startDate', e.target.value);
          }
        }}
        onClick={e => e.stopPropagation()} // Prevent event bubbling
        InputLabelProps={{ shrink: true }}
        size="small"
      />
      <TextField
        label="End Date"
        type="date"
        value={endDate}
        onChange={e => {
          if (e.target.value !== endDate) {
            setEndDate(e.target.value);
            handleDateValues('endDate', e.target.value);
          }
        }}
        onClick={e => e.stopPropagation()} // Prevent event bubbling
        InputLabelProps={{ shrink: true }}
        size="small"
      />
    </div>
  );
};

export default GroundSettlementFilter;
